import React, { useState,useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { useParams } from "react-router-dom";
import { API_URL } from "..";
import QuotePreviewLayer from "../components/QuotePreviewLayer";




const QuotePreviewPage = () => {
     const {id} = useParams();
     const [data,setData]= useState({})
    
      const fetchSingle = async ()=>{
      //  alert(';Please')
        const user = JSON.parse(localStorage.getItem('user'));
         
       let headersList = {
         "Accept": "*/*",
         "Content-Type": "application/json"
        }
        let response = await fetch(API_URL+`/api/invoice/${id}`, { 
          method: "GET",
          headers: headersList
        });
        const data = await response.json();
        
        setData(data)
      }
        useEffect(()=>{
          fetchSingle()
          },[2])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Quote - Preview" />

        {/* InvoicePreviewLayer */}
      {
        data?.invoice_number  === undefined  ? 
        null:
          <QuotePreviewLayer sampleData={data} />
      }
      

      </MasterLayout>

    </>
  );
};

export default QuotePreviewPage;
